export class RefreshTokenError extends Error {

	constructor(message) {
		super(message);
		this.name = 'RefreshTokenError';

		Object.setPrototypeOf(this, RefreshTokenError.prototype);
	}
}
